export default {
  'ticket.serviceNumber': 'Service Number',
  'ticket.time': 'Time',
  'ticket.myOpenTickets': 'My Open Tickets',
  'ticket.myClosedTickets': 'My Closed Tickets',
  'ticket.caseCode': 'Case Code',
  'ticket.title': 'Title',
  'ticket.content': 'Content',
  'ticket.createDate': 'Create Date',
  'ticket.serviceType': 'Service Type',
  'ticket.emergencyType': 'Emergency Type',
  'ticket.caseType': 'Case Type',
  'ticket.contactName': 'Contact Name',
  'ticket.contactPhone': 'Contact Phone',
  'ticket.contactEmail': 'Contact Email',
  'ticket.selectFile': 'Select File',
  'ticket.complaint': 'Complaint',
  'ticket.feedback': 'Feedback',
  'ticket.inquiry': 'Inquiry',
  'ticket.internal': 'Internal',
  'ticket.request': 'Request',
  'ticket.today': 'Today',
  'ticket.reset': 'Reset',
  'ticket.lastSevenDays': 'Last 7 Days',
  'ticket.lastThirtyDays': 'Last 30 Days',
  'ticket.lastSixMonth': 'Last 6 Months',
  'ticket.sanme.file': 'The same image file already exists',
  'ticket.fileLimit': 'File must smaller than {size}MB!',
  'ticket.file.success': 'File uploaded successfully.',
  'ticket.file.error': 'File upload failed.',
  'ticket.file.count': 'Upload maximum 10',
  'ticket.fileType': 'Upload file type can only be {type}',
  'ticket.memberType': 'MemberType',
  'ticket.role': 'Role',
  'ticket.account': 'Account',
  'ticket.subscriptionPlan': 'Subscription Plan',
  'ticket.state': 'State',
  'ticket.active': 'Active',
  'ticket.twoblock': 'Two-Way Block',
  'ticket.oneblock': 'One-Way Block',
  'ticket.termination': 'Termination',
  'ticket.inactive': 'Inactive',
  'ticket.tip': 'Termination at customer request.',
  'ticket.add.success': 'Ticket add successfully.',
  'ticket.add.title': 'New Ticket',
  'ticket.add.accurateInput': 'Accurate-Input',
  'ticket.add.fuzzyInput': 'Fuzzy-Input',
  'ticket.add.fuzzyInputTitle': 'Ticket Content',
  'ticket.add.fuzzyInputTip': 'Ticket Content is Required',
  'ticket.description': 'Description',
  'ticket.footerTip':
    'Kindly refer to your respective U Mobile account manager for the details of each ticket.',
  'ticket.selectFileTip':
    '1.Supported formats include (.+[.])(MP4|MOV|AVI|MP3|WAV|JPG|JPEG|PNG|GIF|TIFF|MSG|PDF|TXT|CSV\n|DOC|DOCX|XLS|XLSX|PPT|PPTX|ZIP|RAR|HTML|mp4|mov|avi|mp3|wav\n|jpg|jpeg|png|gif|tiff|msg|pdf|txt|csv|doc|docx|xls|xlsx|ppt|pptx|zip|rar|\nhtml|xml|xlsm)$\n2.Maximum attachment size limit 5MB',
  'ticket.caseDetail': 'Case Detail',
  'ticket.source': 'Source',
  'ticket.urgency': 'Urgency',
  'ticket.caseCreationTime': 'Case Creation Time',
  'ticket.caseState': 'Case State',
  'ticket.basicInformation': 'Basic Information',
  'ticket.caseInformation': 'Case Information',
  'ticket.caseServiceType': 'Case Service Type',
  'ticket.remark': 'Remark',
  'ticket.taskInformation': 'Task Information',
  'ticket.appointmentDate': 'Appointment Date',
  'ticket.preferredDate': 'Preferred Date',
  'ticket.waitProcess': 'Wait Process',
  'ticket.processing': 'Processing',
  'ticket.closed': 'Closed',
  'ticket.error': 'Error',
  'ticket.suspend': 'Suspend',
  'ticket.NTTProcessing': 'NTT Processing',
  'ticket.NTTFinish': 'NTT Finish',
  'ticket.expired': 'Expired',
  'ticket.taskType': 'Task Type',
  'ticket.assignDate': 'Assign Date',
  'ticket.planCompletionDate': 'Plan Completion Date',
  'ticket.status': 'Status',
  'ticket.suggestedAddress': 'Suggested Address',
  'ticket.offerName': 'Offer Name',
  'ticket.expectedServiceDate': 'Expected Service Date',
  'ticket.installationAddress': 'Installation Address',
  'ticket.maintenancePersonnel': 'Maintenance Personnel',
};
